import {makeAutoObservable, runInAction} from 'mobx';
import RootStore from '../Core/mobx/RootStore';
import AthenaAPI from '../APIs/AthenaAPI';
import {InternalUser} from '@amplify/athena-models';

export class UserAdminStore {
    internalUsers: InternalUser[] | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    getInternalUsers = async () => {
        const response = await AthenaAPI.getAllInternalUsers();

        if (!response) {
            RootStore.uiStore.showSnackbar('Failed to get internal users', 'error');
            return;
        }

        runInAction(() => {
            this.internalUsers = response;
        });
    };

    updateInternalUser = async (user: InternalUser) => {
        try {
            await AthenaAPI.updateInternalUsers([user]);

            runInAction(() => {
                if (this.internalUsers) {
                    this.internalUsers = this.internalUsers.map((i) => (i.email === user.email ? user : i));
                } else {
                    throw new Error('Internal users empty');
                }
            });
            RootStore.uiStore.showSnackbar(`User ${user.email} updated successfully`, 'success');
        } catch (error) {
            console.error('failed to update internal user', error);
            RootStore.uiStore.showSnackbar('Failed to update internal user', 'error');
        }
    };

    addInternalUsers = async (users: InternalUser[]) => {
        try {
            await AthenaAPI.updateInternalUsers(users);

            const newUsers = [...users, ...(this.internalUsers || [])];
            runInAction(() => {
                this.internalUsers = newUsers;
            });
        } catch (error) {
            console.error('failed to add internal user', error);
            RootStore.uiStore.showSnackbar('Failed to update internal user', 'error');
        }
    };
    deleteInternalUser = async (email: string) => {
        try {
            await AthenaAPI.deleteInternalUser(email);

            runInAction(() => {
                if (this.internalUsers) {
                    this.internalUsers = this.internalUsers.filter((i) => i.email !== email);
                } else {
                    throw new Error('Internal users empty');
                }
            });
            RootStore.uiStore.showSnackbar(`User ${email} deleted successfully`, 'success');
        } catch (error) {
            console.error('failed to delete internal user', error);
            RootStore.uiStore.showSnackbar('Failed to delete internal user', 'error');
        }
    };
}
